import { differenceInYears, parseISO, isValid } from 'date-fns'

export const DELAI_MISE_A_JOUR_EN_ANNEES = 2

const CHAMP_DATE_MODIFICATION = 'dateModification'

export const dateDerniereModification = (parametresExploitation) => {
  const valeur = parametresExploitation != null
    ? parametresExploitation[CHAMP_DATE_MODIFICATION]
    : null

  if (valeur == null) {
    return null
  }

  const date = valeur instanceof Date ? valeur : parseISO(String(valeur))

  return isValid(date) ? date : null
}
export const necessiteMiseAJour = (parametresExploitation, maintenant = new Date()) => {
  const date = dateDerniereModification(parametresExploitation)

  if (date == null) {
    return false
  }

  return differenceInYears(maintenant, date) >= DELAI_MISE_A_JOUR_EN_ANNEES
}
